export const ACTIONS = {
  UTI_CWSP_FIRST_BATCH: 'UTI_CWSP_FIRST_BATCH',
  UTI_CWSP_FIRST_BATCH_ERROR: 'UTI_CWSP_FIRST_BATCH_ERROR',
  UTI_CWSP_NEXT_BATCH: 'UTI_CWSP_NEXT_BATCH',
  UTI_CWSP_NEXT_BATCH_ERROR: 'UTI_CWSP_NEXT_BATCH_ERROR',
  UTI_CWSP_BATCH_SUCCESS: 'UTI_CWSP_BATCH_SUCCESS',
  UTI_CWSP_RESET: 'UTI_CWSP_RESET',
};

export const subcollectionPaginationFirstBatch = () => ({
  type: ACTIONS.UTI_CWSP_FIRST_BATCH,
});

export const subcollectionPaginationFirstBatchError = error => ({
  payload: error,
  type: ACTIONS.UTI_CWSP_FIRST_BATCH_ERROR,
});

export const subcollectionPaginationNextBatch = () => ({
  type: ACTIONS.UTI_CWSP_NEXT_BATCH,
});

export const subcollectionPaginationNextBatchError = error => ({
  payload: error,
  type: ACTIONS.UTI_CWSP_NEXT_BATCH_ERROR,
});

export const subcollectionPaginationBatchSuccess = (lastDocument, data, next, hasMore) => ({
  payload: { lastDocument, data, next, hasMore },
  type: ACTIONS.UTI_CWSP_BATCH_SUCCESS,
});

export const subcollectionPaginationReset = () => ({
  type: ACTIONS.UTI_CWSP_RESET,
});